import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'

export const ProviderOutlookMailCommon = {
  key: 'outlookMail',
  authentication: ProviderAuthenticationCommon.Oauth2({
    key: 'outlookMail',
    authUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/authorize`,
    tokenUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/token`,
    scopes: [
      'https://graph.microsoft.com/Mail.ReadWrite',
      'https://graph.microsoft.com/Mail.Send',
      'https://graph.microsoft.com/User.Read',
      'https://graph.microsoft.com/MailboxSettings.ReadWrite',
      'offline_access',
    ],
  }),
}

export type ProviderOutlookMailAccountType = {
  lastMessageDate?: string
  email?: string
}

export type OutlookDraft = {
  '@odata.context': string
  '@odata.etag': string
  id: string
  createdDateTime: string
  lastModifiedDateTime: string
  changeKey: string
  categories: []
  receivedDateTime: string
  sentDateTime: string
  hasAttachments: boolean
  internetMessageId: string
  subject: string
  bodyPreview: string
  importance: 'normal'
  parentFolderId: string
  conversationId: string
  conversationIndex: string
  isDeliveryReceiptRequested: boolean
  isReadReceiptRequested: boolean
  isRead: boolean
  isDraft: boolean
  webLink: string
  inferenceClassification: string
  body: {
    contentType: string
    content: string
  }
  sender: {
    emailAddress: { name: string; address: string }
  }
  from: {
    emailAddress: { name: string; address: string }
  }
  toRecipients: { emailAddress: { name: string; address: string } }[]
  ccRecipients: []
  bccRecipients: []
  replyTo: []
  flag: { flagStatus: string }
}
